/**
 * Put the auth guard in front of whatever guard a route already declares.
 *
 * WHY THIS IS ITS OWN FILE. Vue Router accepts `beforeEnter` as a function OR
 * an array of them (since 4.1). The composition here used to be written inline
 * as `[authGuard, existing]`, which is correct for the function case and
 * silently wrong for the other: an existing array becomes `[auth, [a, b]]`, and
 * the router calls `.call()` on the inner array. The navigation then dies with
 * `TypeError: e.call is not a function`, thrown from minified router internals,
 * with nothing in the stack naming the route that caused it — the trap costs
 * far more to diagnose than it does to prevent, so it is prevented here and
 * covered by a test.
 *
 * @param {Function} authGuard the guard that must run first
 * @param {Function|Function[]|undefined} existing the route's own guard(s)
 * @returns {Function|Function[]} a shape Vue Router can call
 */
export function composeBeforeEnter(authGuard, existing) {
  if (!existing) return authGuard;
  return [authGuard, ...[existing].flat()];
}
